import { render, staticRenderFns } from "./ModalStars.vue?vue&type=template&id=566f9ba8&scoped=true&"
import script from "./ModalStars.vue?vue&type=script&lang=js&"
export * from "./ModalStars.vue?vue&type=script&lang=js&"
import style0 from "./ModalStars.vue?vue&type=style&index=0&id=566f9ba8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f9ba8",
  null
  
)

component.options.__file = "ModalStars.vue"
export default component.exports